import { render, staticRenderFns } from "./ReaderForm.vue?vue&type=template&id=c775360a&"
import script from "./ReaderForm.vue?vue&type=script&lang=js&"
export * from "./ReaderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports